/**
 * En-tête `X-Device-Info` : les quelques signaux que le navigateur est seul à
 * connaître (fuseau, langue, résolution).
 *
 * Ils servent au calcul de l'empreinte technique de l'appareil et au libellé
 * lisible affiché dans l'espace Sécurité - jamais à décider d'un accès. Le
 * serveur ne leur fait aucune confiance : c'est le cookie `cb_did`, qu'il émet
 * lui-même et que ce fichier ne voit pas (il est `HttpOnly`), qui identifie
 * l'appareil.
 *
 * Encodage base64url pour rester transportable dans un en-tête HTTP quels que
 * soient les caractères du fuseau ou de la langue.
 */
export const enteteInfoAppareil = () => {
  try {
    const info = {
      fuseau: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      langue: navigator.language || '',
      resolution: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
    };
    const json = JSON.stringify(info);
    // encodeURIComponent + unescape : passe les caractères non ASCII à btoa,
    // qui ne sait traiter que du latin-1 et lèverait sinon une InvalidCharacterError.
    const base64 = btoa(unescape(encodeURIComponent(json)));
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  } catch {
    // Un navigateur qui refuse ces API n'est pas une raison d'empêcher la
    // connexion : le serveur sait travailler sans cet en-tête.
    return '';
  }
};

/** En-têtes à joindre aux appels d'authentification. */
export const entetesAppareil = () => {
  const info = enteteInfoAppareil();
  return info ? { 'X-Device-Info': info } : {};
};
